<template>
  <div class="scree-box">
    <div class="select-scree" :style="{ 'justify-content': isShowIncomeAndExpend ? 'space-between' : 'flex-start' }">
      <div @click="onClickScreeItem(IntegralScreeColumnsTypeEnum.DATE)" :class="{ 'mr-10px': !isShowIncomeAndExpend }">
        <span>{{ fastDateLabel }}</span>
        <van-icon name="play" class="down-arrow" />
      </div>
      <div v-if="isShowIncomeAndExpend" @click="onClickScreeItem(IntegralScreeColumnsTypeEnum.INCOME_AND_EXPEND)">
        <span>{{ incomeAndExpendLabel }}</span>
        <van-icon name="play" class="down-arrow" />
      </div>
      <div @click="onClickScreeItem(IntegralScreeColumnsTypeEnum.STATUS)">
        <span>{{ integralStatusLabel }}</span>
        <van-icon name="play" class="down-arrow" />
      </div>
    </div>
    <div class="date-scree">
      <div class="date-box" @click="timeChangeShow('startDate')">
        <van-icon class="date-icon" :name="dateIcon" />
        <span>{{ time.startDate || '开始时间' }} </span>
      </div>
      <div>-</div>
      <div class="date-box" @click="timeChangeShow('endDate')">
        <van-icon class="date-icon" :name="dateIcon" />
        <span>{{ time.endDate || '结束时间' }}</span>
      </div>
    </div>
  </div>
  <van-popup v-model:show="time.timeWhen" position="bottom">
    <van-date-picker
      v-model="show_time"
      title="选择年月日"
      @confirm="onConfirmDateTimePicker"
      @cancel="onCancelTime"
      :min-date="minDate"
      :max-date="maxDate"
    />
  </van-popup>
  <van-popup
    v-model:show="showTypePicker"
    round
    position="bottom"
    safe-area-inset-bottom
    :close-on-click-overlay="false"
  >
    <van-picker :columns="getScreeTypeColumns" @cancel="showTypePicker = false" @confirm="onTypeConfirm" />
  </van-popup>
</template>
<script setup>
import { ref, computed, onMounted } from 'vue'
import useTime from '@/utils/time'
import utils from '@/utils'
import dateIcon from '@/assets/img/date.png'
import {
  IntegralFastDateColumns,
  IntegralIncomeAndExpendColumns,
  IncomeAndExpendTypeEnum,
  IntegralStatusEnum,
  IntegralStatusColumns,
  FastDataEnum,
  IntegralScreeColumnsTypeEnum
} from '../integral.data'

const props = defineProps({
  isShowIncomeAndExpend: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['search'])

// 具体时间选择
const { time, show_time, timeChangeShow, onConfirmTime, onCancelTime } = useTime()
const minDate = new Date(2020, 0, 1)
const maxDate = new Date(2025, 10, 1)
const onConfirmDateTimePicker = val => {
  fastDateVal.value = FastDataEnum.ALL
  onConfirmTime(val, null, 0)
  emitSearch()
}

// 快捷时间
const fastDateVal = ref(FastDataEnum.ALL)
const fastDateLabel = ref('全部时间')

//收支
const incomeAndExpend = ref(props.isShowIncomeAndExpend ? IncomeAndExpendTypeEnum.ALL : IncomeAndExpendTypeEnum.EXPEND)
const incomeAndExpendLabel = ref('全部收支')

// 状态
const integralStatus = ref(IntegralStatusEnum.ALL)
const integralStatusLabel = ref('全部状态')

//Picker
const showTypePicker = ref(false)
const selectColumnsType = ref(IntegralScreeColumnsTypeEnum.DATE)
const getScreeTypeColumns = computed(() => {
  return {
    [IntegralScreeColumnsTypeEnum.DATE]: IntegralFastDateColumns,
    [IntegralScreeColumnsTypeEnum.INCOME_AND_EXPEND]: IntegralIncomeAndExpendColumns,
    [IntegralScreeColumnsTypeEnum.STATUS]: props.isShowIncomeAndExpend
      ? IntegralStatusColumns
      : IntegralStatusColumns.filter(d =>
          [
            IntegralStatusEnum.ALL,
            IntegralStatusEnum.WAIT_CHECK,
            IntegralStatusEnum.HAS_SUCCESS,
            IntegralStatusEnum.HAS_REFUSE,
            IntegralStatusEnum.ORDER_SUCCESS
          ].includes(d.value)
        )
  }[selectColumnsType.value]
})
const onClickScreeItem = type => {
  selectColumnsType.value = type
  showTypePicker.value = true
}
const onTypeConfirm = ({ selectedOptions }) => {
  const { text, value } = selectedOptions[0]
  switch (selectColumnsType.value) {
    case IntegralScreeColumnsTypeEnum.DATE:
      fastDateVal.value = value
      fastDateLabel.value = text
      break
    case IntegralScreeColumnsTypeEnum.INCOME_AND_EXPEND:
      incomeAndExpend.value = value
      incomeAndExpendLabel.value = text
      break
    default:
      integralStatus.value = value
      integralStatusLabel.value = text
      break
  }

  //设置时间
  if (IntegralScreeColumnsTypeEnum.DATE === selectColumnsType.value) {
    console.log(value)
    const { startDate, endDate } = utils.computedTime(value)
    time.startDate = startDate
    time.endDate = endDate
  }
  emitSearch()
  showTypePicker.value = false
}

const emitSearch = () => {
  emit('search', {
    incomeType: incomeAndExpend.value,
    status: integralStatus.value,
    startTime: time.startDate,
    endTime: time.endDate
  })
}
onMounted(emitSearch)
</script>
<style lang="less" scoped>
.scree-box {
  padding: 16px;
  background-color: #fff;
  border-bottom: 1px solid #f4f4f4;
  .select-scree {
    display: flex;
    align-items: center;
    > div {
      width: 100px;
      padding: 8px;
      background: #fafafb;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .down-arrow {
        transform: rotate(90deg);
      }
    }
  }
  .date-scree {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    > .date-box {
      // display: flex;
      // align-items: center;
      width: 145px;
      padding: 8px;
      height: 32px;
      background: #fafafb;
      border-radius: 4px;
      color: #999999;
      display: flex;
      align-items: center;
      .date-icon {
        // width: 10px;
        // height: 10px;
        margin-right: 5px;
      }
      //   > span {
      // vertical-align: bottom;
      //   }
    }
  }
}
.mr-10px {
  margin-right: 10px;
}
</style>
